function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeesCharged({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#C0483F",
    fillOpacity: 0.08,
    style: {
      fill: "#C0483F",
      fill: "color(display-p3 0.7529 0.2824 0.2471)",
      fillOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3 15.92V21.07C27.3 24.15 25.54 25.47 22.9 25.47H14.11C13.66 25.47 13.23 25.43 12.83 25.34C12.58 25.3 12.34 25.23 12.12 25.15C10.62 24.59 9.70996 23.29 9.70996 21.07V15.92C9.70996 12.84 11.47 11.52 14.11 11.52H22.9C25.14 11.52 26.75 12.47 27.18 14.64C27.25 15.04 27.3 15.45 27.3 15.92Z",
    stroke: "#C0483F",
    style: {
      stroke: "#C0483F",
      stroke: "color(display-p3 0.7529 0.2824 0.2471)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3011 18.9201V24.0701C30.3011 27.1501 28.5411 28.4701 25.9011 28.4701H17.1111C16.3711 28.4701 15.7011 28.3701 15.1211 28.1501C13.9311 27.7101 13.1211 26.8001 12.8311 25.3401C13.2311 25.4301 13.6611 25.4701 14.1111 25.4701H22.9011C25.5411 25.4701 27.3011 24.1501 27.3011 21.0701V15.9201C27.3011 15.4501 27.2611 15.0301 27.1811 14.6401C29.0811 15.0401 30.3011 16.3801 30.3011 18.9201Z",
    stroke: "#C0483F",
    style: {
      stroke: "#C0483F",
      stroke: "color(display-p3 0.7529 0.2824 0.2471)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4984 21.1399C19.9564 21.1399 21.1384 19.9579 21.1384 18.4999C21.1384 17.0418 19.9564 15.8599 18.4984 15.8599C17.0404 15.8599 15.8584 17.0418 15.8584 18.4999C15.8584 19.9579 17.0404 21.1399 18.4984 21.1399Z",
    stroke: "#C0483F",
    style: {
      stroke: "#C0483F",
      stroke: "color(display-p3 0.7529 0.2824 0.2471)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7803 16.2998V20.6998",
    stroke: "#C0483F",
    style: {
      stroke: "#C0483F",
      stroke: "color(display-p3 0.7529 0.2824 0.2471)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2217 16.3003V20.7003",
    stroke: "#C0483F",
    style: {
      stroke: "#C0483F",
      stroke: "color(display-p3 0.7529 0.2824 0.2471)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeesCharged);
export default __webpack_public_path__ + "static/media/fees-charged.cbab422064edd5e41743d2998915cb40.svg";
export { ForwardRef as ReactComponent };